
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.md?watch=parent';
    export const demoIndex = {
  ids: ["gptvis-demo-default","gptvis-demo-relation","gptvis-demo-tag","gptvis-demo-code","gptvis-demo-error-render","gptvis-demo-resize-render","gptvis-demo-resize-component","gptvis-demo-event","gptvis-demo-context-provider"],
  getter: () => import(/* webpackChunkName: "meta__GPTVis" */'/home/runner/work/GPT-Vis/GPT-Vis/src/GPTVis/index.md?type=demo')
};